import { render, staticRenderFns } from "./CampaignItemSetup.vue?vue&type=template&id=3615061e&scoped=true&"
import script from "./CampaignItemSetup.vue?vue&type=script&lang=js&"
export * from "./CampaignItemSetup.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemSetup.vue?vue&type=style&index=0&id=3615061e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615061e",
  null
  
)

export default component.exports